import type { ComponentPropsWithoutRef, ElementType } from "react";

import { styled } from "simplydo/react/styled";

const StyledBasic = styled.button`
  background: transparent none;
  color: rgba(0, 0, 0, 0.6);
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
  font-weight: normal !important;

  &:hover,
  &:focus {
    background-color: transparent;
    color: rgba(0, 0, 0, 0.8);
    box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.35) inset;
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

type Props = ComponentPropsWithoutRef<"button"> & {
  as?: ElementType;
  className?: string;
};

export function BasicButton({ as, className, ...props }: Props) {
  return <StyledBasic as={as} className={className} {...props} />;
}
